import { CustomIcon } from "components/icon/customIcon.component";
import { TimeReportsSummaryCard } from "./timeReportsSummaryCards.types";
import {
  Card,
  CardsRow,
  ContentColumn,
  IconSlot,
  Label,
  Value,
} from "./timeReportsSummaryCards.styled";

interface TimeReportsSummaryCardsProps {
  cards: TimeReportsSummaryCard[];
  onCardClick: (card: TimeReportsSummaryCard) => void;
}

export const TimeReportsSummaryCards = (
  props: TimeReportsSummaryCardsProps,
): JSX.Element => {
  return (
    <CardsRow $cardColumns={props.cards.length}>
      {props.cards.map((card) => (
        <Card
          key={card.id}
          type="button"
          $isHighlighted={Boolean(card.isHighlighted)}
          onClick={() => props.onCardClick(card)}
          aria-pressed={Boolean(card.isHighlighted)}
        >
          <IconSlot>
            <CustomIcon name={card.iconName} size="20px" color={card.color} />
          </IconSlot>
          <ContentColumn>
            <Value $color={card.color}>{card.value}</Value>
            <Label>{card.label}</Label>
          </ContentColumn>
        </Card>
      ))}
    </CardsRow>
  );
};
